import { get, set } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import './PrimaryAddress.scss';
import { Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FormControl from '../../../../shared/components/Form/FormControl';
import Select from '../../../../shared/components/Select';

const PRIMARY_ADDRESS_FIELDS = [
  'first_name',
  'last_name',
  'address',
  'address_2',
  'city',
  'state',
  'zip'
];

const PrimaryAddress = ({ formik, countries = [], includePhone = false, loading = false, colSize = 4 }) => {
  const { t } = useTranslation();
  const addressFields = useCallback(() => {
    if (includePhone)
      return [...PRIMARY_ADDRESS_FIELDS, "phone"]
    else
      return PRIMARY_ADDRESS_FIELDS;
  }, [])

  const fields = addressFields().map((field, idx) => {
    const isTouched = formik.touched.address && formik.touched.address[field];
    const hasStatus = get(formik.status, `address.${field}`);
    const hasError = !!(formik.errors.address && formik.errors.address[field]) || !!hasStatus;
    const errorMessage = (formik.errors.address && formik.errors.address[field]) || hasStatus;
    const lastElement = (idx + 1) % 2 === 0;

    return (
      <React.Fragment key={field}>
        <Col xs={12} sm={colSize}>
          <Form.Group>
            <Form.Label>
              {t(`influencers.pages.profile.general.${field}`)}
            </Form.Label>
            <FormControl
              type="text"
              placeholder={t(`influencers.pages.profile.general.${field}`)}
              name={`address.${field}`}
              onChange={(e) => {
                hasStatus && set(formik.status, `address.${field}`, '');
                formik.handleChange(e);
              }}
              value={get(formik.values, `address.${field}`, '')}
              error={isTouched && hasError}
              onBlur={formik.handleBlur}
              disabled={loading}
            />
            {isTouched && hasError && (
              <Form.Text className="text-muted danger-text">
                {errorMessage}
              </Form.Text>
            )}
          </Form.Group>
        </Col>
        {lastElement && colSize == 4 && <Col sm={colSize} />}
      </React.Fragment>
    );
  });

  return (
    <React.Fragment>
      {fields}

      <Col xs={12} sm={colSize}>
        <Form.Group>
          <Form.Label>
            {t(`influencers.pages.profile.general.country`)}
          </Form.Label>
          {countries.length > 0 && (
            <Select
              className="mb-2 primary-address-select"
              name="address.country"
              value={formik.values.address.country}
              error={get(formik, 'touched.address.country') && get(formik, 'errors.address.country')}
              onChange={formik.handleChange}
              disabled={loading}
              onBlur={formik.handleBlur}
              options={countries.map(country => ({
                label: country.name,
                value: country.name
              }))}
            />
          )}
          {get(formik, 'touched.address.country') && get(formik, 'errors.address.country') && (
            <Form.Text className="text-muted danger-text">
              {formik.errors.address.country}
            </Form.Text>
          )}
        </Form.Group>
      </Col>
    </React.Fragment>
  );
};

PrimaryAddress.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
    status: PropTypes.object,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
  }).isRequired,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ),
  loading: PropTypes.bool,
  colSize: PropTypes.number,
};

export default PrimaryAddress;
